import React, { useCallback, useContext } from 'react';
import { OperationsContext } from '../OperationsContext';
import { Segment,Icon, Statistic, StatisticGroup, StatisticLabel, StatisticValue } from 'semantic-ui-react';

const RenewalClientStats = () => {
	const { renewal } = useContext( OperationsContext );

	const mapStats = useCallback( () => renewal?.stats.map( ( { color, label, value } ) => (
  <Segment
    key={label}
      style={{
          flex: 1,
          margin: '0 1rem',
          borderRadius: 12,
          padding: '1.5rem',
          boxShadow: '0 2px 10px rgba(0,0,0,.08)',
          borderTop: `4px solid ${color}`,
          transition: '.2s'
      }}
  >
    <Statistic style={{ margin: 0 }}>
      <StatisticLabel
        style={{
            textTransform: 'uppercase',
            letterSpacing: 1,
            color: '#666',
            fontSize: '.85rem',
            overflow: 'hidden',
            whiteSpace: 'no-wrap',
            textOverflow: 'ellipsis'
        }}
      >
        <Icon
          name="chart line"
          style={{
            color,
            marginBottom: '1rem'
          }}
        />
          { label }
        </StatisticLabel>
        <StatisticValue
          style={{
            color,
            fontSize: '3rem',
            fontWeight: 700,
            marginTop: '.5rem'
          }}
        >
          { value }
        </StatisticValue>
      </Statistic>
    </Segment>
	) ), [ renewal ] );

	return (
		<>
			{ renewal?.stats
				? <StatisticGroup
					size="small"
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						margin: '1em -1em'
					}}
				>
					{ mapStats() }
				</StatisticGroup>
				: null
			}
		</>
	);
};

export default RenewalClientStats;
